
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/order-confirmation",
      function () {
        return require("private-next-pages/design-system/examples/order-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/order-confirmation"])
      });
    }
  